import { render, staticRenderFns } from "./FormPetugasEdit.vue?vue&type=template&id=11bdca2c&"
import script from "./FormPetugasEdit.vue?vue&type=script&lang=js&"
export * from "./FormPetugasEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports